













































import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import {
  NumberInput,
} from "../../../../../../base/components/system";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import {
  ISize,
} from "../../../../../../base/domain/drawing";
import {
  FormatStructureEditableMixin,
  UploadImageFileMixin,
  CommonComponentsAccessibleMixin,
} from "../../mixins";
import { DomainRegistry } from "../../../../../domain";
import {
  IEditableFormatLayer,
  BackgroundImageCombination, FormatPageStructureEditor
} from "../../../../../domain/editableFormat";
import SingleFlowLayoutSelector from "../../../../../../base/components/system/selectors/SingleFlowLayoutSelector.vue";

@Component({
  components: {
    NumberInput,
    SingleFlowLayoutSelector,
  }
})
export default class FormatPageBackgroundImageEditTool extends Mixins(FormatStructureEditableMixin, ModelEditableMixin, UploadImageFileMixin, CommonComponentsAccessibleMixin) {
  layers: IEditableFormatLayer[] = [];
  selectingLayer: IEditableFormatLayer = null;

  $refs!: {
    input: HTMLInputElement,
  };

  get allSelectedPagesAreLayer(): boolean {
    return this.selectedPagesEditor
      ? !!this.selectedPagesEditor.layer().getValue().imageGuid
      : false;
  }

  get layerX(): number {
    return this.selectedPagesEditor
      ? this.selectedPagesEditor.layer().getValue().location.x
      : 0;
  }

  set layerX(value: number) {
    const layer = this.selectedPagesEditor.layer().getValue();
    this.writeSelectedPagesEditorWhenValid(s => s.layer().setValue({
      formatId: layer.formatId,
      sectionNo: layer.sectionNo,
      imageGuid: layer.imageGuid,
      location: {
        x: value,
        y: layer.location.y,
      },
      size: layer.size,
      fileName: layer.fileName,
    }));
  }

  get layerY(): number {
    return this.selectedPagesEditor
      ? this.selectedPagesEditor.layer().getValue().location.y
      : 0;
  }

  set layerY(value: number) {
    const layer = this.selectedPagesEditor.layer().getValue();
    this.writeSelectedPagesEditorWhenValid(s => s.layer().setValue({
      formatId: layer.formatId,
      sectionNo: layer.sectionNo,
      imageGuid: layer.imageGuid,
      location: {
        x: layer.location.x,
        y: value,
      },
      size: layer.size,
      fileName: layer.fileName,
    }));
  }

  get layerWidth(): number {
    return this.selectedPagesEditor
      ? this.selectedPagesEditor.layer().getValue().size.width
      : 0;
  }

  set layerWidth(value: number) {
    const layer = this.selectedPagesEditor.layer().getValue();
    const ratio = value / layer.size.width;
    this.writeSelectedPagesEditorWhenValid(s => s.layer().setValue({
      formatId: layer.formatId,
      sectionNo: layer.sectionNo,
      imageGuid: layer.imageGuid,
      location: layer.location,
      size: {
        width: value,
        height: Math.ceil(layer.size.height * ratio),
      },
      fileName: layer.fileName,
    }));
  }

  get layerHeight(): number {
    return this.selectedPagesEditor
      ? this.selectedPagesEditor.layer().getValue().size.height
      : 0;
  }

  set layerHeight(value: number) {
    const layer = this.selectedPagesEditor.layer().getValue();
    const ratio = value / layer.size.height;
    this.writeSelectedPagesEditorWhenValid(s => s.layer().setValue({
      formatId: layer.formatId,
      sectionNo: layer.sectionNo,
      imageGuid: layer.imageGuid,
      location: layer.location,
      size: {
        width: Math.ceil(layer.size.width * ratio),
        height: value,
      },
      fileName: layer.fileName,
    }));
  }

  get isBackgroundImageSelectable(): boolean {
    return this.layers.length > 0;
  }

  mounted(): void {
    this.layers = Enumerable.from(this.pages)
      .where(p => !!p.layer().getValue().formatId)
      .distinct(p => p.layer().getValue().imageGuid)
      .select(p => {
        const layer = p.layer().getValue();
        return {
          formatId: layer.formatId,
          sectionNo: layer.sectionNo,
          imageGuid: layer.imageGuid,
          location: {
            x: 0,
            y: 0,
          },
          size: layer.size,
          fileName: layer.fileName,
        };
      })
      .toArray();
  }

  uploadedImage(imageGuid: string, size: ISize<number>, fileName: string): void {
    this.layers.unshift({
      formatId: null as number,
      sectionNo: null as number,
      imageGuid: imageGuid,
      location: {
        x: 0,
        y: 0,
      },
      size: size,
      fileName: fileName,
    });
  }

  openDialog(): void {
    this.$refs.input.click();
  }

  handleAdd(): void {
    const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
    this.selectingLayer.formatId
      ? repository.getNewCopiedLatestBackgroundImageGuid(this.selectingLayer.formatId, this.selectingLayer.imageGuid).then(d => this.setAdditionalLayer(d))
      : repository.getNewTemporaryImageGuid(this.selectingLayer.imageGuid).then(d => this.setAdditionalLayer(d));
  }

  private setAdditionalLayer(guid: string) {
    const layerSize = this.getAdditionalLayerSize();
    this.writeSelectedPagesEditorWhenValid(s => s.layer().setValue({ 
      formatId: null,
      sectionNo: null,
      imageGuid: guid,
      location: this.selectingLayer.location,
      size: layerSize,
      fileName: this.selectingLayer.fileName,
    }));
  }

  private getAdditionalLayerSize(): ISize<number> {
    const pageSize = this.selectedPagesEditor.size().getValue();
    // ページサイズから余白を除いた下地画像の最大サイズを計算
    const layerSize = {
      width: pageSize.width - 38.4,
      height: pageSize.height - 38.4,
    };
    const selectingLayerSize = this.selectingLayer.size;
    if (layerSize.width < selectingLayerSize.width
      || layerSize.height < selectingLayerSize.height) {
      const rate = Math.min((layerSize.width / selectingLayerSize.width), (layerSize.height / selectingLayerSize.height));
      return  {
        width: selectingLayerSize.width * rate,
        height: selectingLayerSize.height * rate,
      };
    }
    return selectingLayerSize;
  }

  handleRemove(): void {
    this.writeSelectedPagesEditorWhenValid(s => s.layer().setValue({
      formatId: null,
      sectionNo: null,
      imageGuid: null,
      location: {
        x: 0,
        y: 0,
      },
      size: {
        width: 0,
        height: 0,
      },
      fileName: "",
    }));
  }

  toImageStyle(value: IEditableFormatLayer): any {
    return value
      ? {
        width: "350px",
        height: "330px",
        backgroundImage: "url(" + this.toLayerSource(value) + ")",
      }
      : null;
  }

  private toLayerSource(layer: IEditableFormatLayer): string {
    if (!layer || !layer.imageGuid) {
      return null;
    }
    const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
    const imageSource = layer.formatId
      ? repository.getLayerImageSource(layer.formatId, layer.imageGuid)
      : repository.getTemporaryImageSource(layer.imageGuid);
    return imageSource.source;
  }

  equivalentValidator(source: IEditableFormatLayer, destination: IEditableFormatLayer): boolean {
    return source === destination &&
      source.formatId === destination.formatId &&
      source.imageGuid === destination.imageGuid;
  }

  async showBackgroundImageSelectDialog(): Promise<void> {
    const dialog = this.getCommonComponents().getDialogs().getBackgroundImageSelectDialog();
    const result = await dialog.show(this.layers.concat(), this.pageCount);
    if (result) {
      await this.updateAllPagesFormatlayers(result);
    }
  }

  async updateAllPagesFormatlayers(layers: BackgroundImageCombination[]): Promise<void> {
    this.writePropertyWhenValid(async s => {
      const pages = s.getPages();
      const newPages = [] as FormatPageStructureEditor[];
      for (const page of pages) {
        newPages.push(await this.getNewPageFormatlayer(page, layers));
      }
      s.updatePages(newPages);
    });
  }

  async getNewPageFormatlayer(page: FormatPageStructureEditor, layers: BackgroundImageCombination[]): Promise<FormatPageStructureEditor> {
    const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
    const clone = page.clone();
    const layerInformation = layers.find(l => l.pageNumber === this.getCommonComponents().getPageNumber(page.pageKey().getValue()));
    if (layerInformation) {
      if (!layerInformation.layer.imageGuid) {
        clone.layer().setValue(layerInformation.layer);
      } else {
        const guid = layerInformation.layer.formatId
          ? await repository.getNewCopiedLatestBackgroundImageGuid(layerInformation.layer.formatId, layerInformation.layer.imageGuid)
          : await repository.getNewTemporaryImageGuid(layerInformation.layer.imageGuid);
        clone.layer().setValue({
          formatId: null,
          sectionNo: null,
          imageGuid: guid,
          location: layerInformation.layer.location,
          size: layerInformation.layer.size,
          fileName: layerInformation.layer.fileName,
        });
      }
    }
    return clone;
  }
}
